// Single source of truth for turning an axios/unknown failure into a message we
// can show a user. Prefers the server's own `response.data.message` (or `.error`)
// so real validation / rate-limit / guidance copy surfaces verbatim, and falls
// back to a caller-supplied string when the server said nothing usable. Replaces
// the several ad-hoc copies that used to drop the server's reason on the floor.

function extractServerMessage(err: unknown): string | null {
  const data = (err as { response?: { data?: unknown } } | undefined)?.response
    ?.data;
  if (data && typeof data === "object") {
    const obj = data as Record<string, unknown>;
    if (typeof obj.message === "string" && obj.message.trim().length > 0) {
      return obj.message;
    }
    if (typeof obj.error === "string" && obj.error.trim().length > 0) {
      return obj.error;
    }
  }
  return null;
}

export function serverErrorMessage(
  err: unknown,
  fallback = "Something went wrong. Please try again."
): string {
  return extractServerMessage(err) ?? fallback;
}
